import { createReducer, on } from '@ngrx/store';
import {
    cancelModalContinueClicked,
    displayCancelModal,
    hideCancelModal,
    resetCancelModal,
    resetCancelModalforInitiateAndReleaseTable
} from '../actions/shared.actions';
import { cancelModalSourceTypes } from '../utilities/Constants';

export const cancelModalKey = 'cancelModal';

export type cancelModalState = {
  active: boolean;
  continueClicked: boolean;
  nextUrlState: string;
  title?: string;
  content?: string[];
  greenButton?: string;
  grayButton?: string;
  isL1Nav?: boolean;
  isQuicklinksNav?: boolean;
  source: cancelModalSourceTypes;
};
export const initialdisplayCancelModal: cancelModalState = {
  active: false,
  continueClicked: false,
  nextUrlState: '',
  title: '',
  content: [],
  greenButton: '',
  grayButton: '',
  isL1Nav: false,
  isQuicklinksNav: false,
  source: ''
};

export const cancelModalReducer = createReducer(
  initialdisplayCancelModal,
  on(displayCancelModal, (_state, { nextUrlState, title, content, greenButton, grayButton, isL1Nav, isQuicklinksNav, source }) => {
    return {
      continueClicked: false,
      active: true,
      nextUrlState: nextUrlState,
      title: title,
      content: content,
      greenButton: greenButton,
      grayButton: grayButton,
      isL1Nav: isL1Nav,
      isQuicklinksNav: isQuicklinksNav,
      source: source
    };
  }),
  on(hideCancelModal, (state) => {
    return {
      ...state,
      active: false,
      title: '',
      content: [],
    };
  }),
  on(cancelModalContinueClicked, (state) => {
    return {
      ...state,
      active: false,
      continueClicked: true,
      title: '',
      content: [],
    };
  }),
  on(resetCancelModal, (state) => {
    return {
      ...state,
      continueClicked: false
    };
  }),
  on(resetCancelModalforInitiateAndReleaseTable, (state) => {
    return {
      ...state,
      continueClicked: true
    };
  })
);
